exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "dim-overlay {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.8);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.15s linear;\n}\ndim-overlay.has-child {\n  opacity: 1;\n  pointer-events: all;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"plugins":[{}]}!./src/app/common/components/dim-overlay/dim-overlay.component.less
// module id = YSKO
// module chunks = 1